import React, { useState } from 'react'
import {
  PlayerCardContainer,
  PlayerCardHeader,
  PlayerInitials,
  PlayerInfo,
  PlayerName,
  PlayerNameContainer,
  PositionBadge,
  PlayerDetails,
  CollegeLogoContainer,
  CollegeLogo,
  PlayerRanking,
  RankBadge,
  RankValue,
  RankLabel,
  PlayerAnalysis,
  ExpandButton,
  ChangeValue,
  CollegeImageContainer,
  CollegeImage,
} from './styles'
import { PlayerCardProps } from './types'
import {
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
} from '../../../Components/LazyComponents/lazyIcons'
import { Tooltip } from '../../../Components/LazyComponents/Tooltip/Tooltip'

export const PlayerCard: React.FC<PlayerCardProps> = ({ player }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  // Get player initials for fallback display
  const getPlayerInitials = (name: string) => {
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .substring(0, 2)
      .toUpperCase()
  }

  const returnChangeValue = (change: number) => {
    let changeValue = '-'
    if (change > 0) changeValue = `+${change}`
    if (change < 0) changeValue = `${change}`

    return <ChangeValue change={change}>{changeValue}</ChangeValue>
  }

  return (
    <PlayerCardContainer>
      <PlayerCardHeader onClick={toggleExpand}>
        <CollegeImageContainer>
          {player?.collegeLogo ? (
            <CollegeImage src={player.collegeLogo} alt={player.playerName} />
          ) : (
            <PlayerInitials>{getPlayerInitials(player.playerName)}</PlayerInitials>
          )}
        </CollegeImageContainer>
        <PlayerInfo>
          <PlayerNameContainer>
            <PlayerName>{player.playerName}</PlayerName>
            <PositionBadge>
              <p className="posCode">{player.position}</p>
            </PositionBadge>
          </PlayerNameContainer>
          <PlayerDetails>
            <div className="playerDetail">
              {player.collegeLogo && (
                <CollegeLogoContainer>
                  <CollegeLogo src={player.collegeLogo} alt={`${player.college} logo`} />
                </CollegeLogoContainer>
              )}
              <p>{player.college}</p>
            </div>
          </PlayerDetails>
        </PlayerInfo>
        <PlayerRanking>
          <Tooltip title="Overall Rank" placement="top">
            <RankBadge>
              <RankValue>{player.overallRank}</RankValue>
              <RankLabel>OVR RK</RankLabel>
            </RankBadge>
          </Tooltip>
          <Tooltip title="Position Rank" placement="top">
            <RankBadge>
              <RankValue>{player.positionRank}</RankValue>
              <RankLabel>Pos RK</RankLabel>
            </RankBadge>
          </Tooltip>
          <Tooltip title="Change From Previous" placement="top">
            <RankBadge>
              {returnChangeValue(player.change)}
              <RankLabel>CHG</RankLabel>
            </RankBadge>
          </Tooltip>
          <ExpandButton>
            {isExpanded ? (
              <KeyboardArrowUpIcon style={{ transform: 'rotate(0deg)' }} />
            ) : (
              <KeyboardArrowDownIcon style={{ transform: 'rotate(0deg)' }} />
            )}
          </ExpandButton>
        </PlayerRanking>
      </PlayerCardHeader>
      <PlayerAnalysis isExpanded={isExpanded}>
        <p className="title">Draft Analysis</p>
        <p className="analysis">{player.analysis}</p>
      </PlayerAnalysis>
    </PlayerCardContainer>
  )
}
